/**
 * Builder de `playerSource` DASH+Widevine para Bitmovin.
 *
 * Versión Mundial2026 — adapter del `getDash` del LivePlayer al contrato
 * camelCase que devuelve `getMatchPlaybackService` (`videoUrl`, `serverUrl`,
 * `certificateUrl`). El envelope Widevine (JSON con `widevineBody` base64) y
 * el robustness level (`SW_SECURE_CRYPTO`) son los mismos.
 */
import toUTF8 from 'containers/Player/utils/toUTF8';

export const getDash = async (media, deviceId) => {
  let certificate;
  let challenge;

  if (media?.certificateUrl) {
    const cert = await fetch(media.certificateUrl);
    const certBuffer = await cert.arrayBuffer();
    certificate = new Uint8Array(certBuffer);
  }

  // Mismo criterio defensivo que en getHLS: token directo en Mundial2026,
  // fallback a `custom-data` envuelto si algún canal viene en formato legacy.
  if (media?.challenge) {
    challenge = JSON.parse(media.challenge);
    if (challenge?.['custom-data']) {
      challenge.token = JSON.parse(challenge['custom-data'])?.token;
    }
  }

  const configDrm = {
    videoRobustness: 'SW_SECURE_CRYPTO',
    audioRobustness: 'SW_SECURE_CRYPTO',
  };

  if (media?.serverUrl) {
    configDrm.LA_URL = media.serverUrl;
  }
  if (media?.certificateUrl) {
    configDrm.certificateURL = media.certificateUrl;
    configDrm.serverCertificate = certificate;
    configDrm.prepareMessage = keyMessage =>
      new Uint8Array(
        toUTF8(
          JSON.stringify({
            token: challenge?.token || '',
            device_id: deviceId,
            widevineBody: btoa(
              String.fromCharCode.apply(
                null,
                new Uint8Array(keyMessage?.message),
              ),
            ),
          }),
        ),
      ).buffer;
  }

  const playerSource = {
    dash: media.videoUrl,
    drm: {
      widevine: configDrm,
    },
  };
  return playerSource;
};
